import styled from 'styled-components/macro'

const ResponsiveImage = styled.img`
  width: 100%;
`

export default ResponsiveImage
